export interface ICommonModel {
    id?: string,
    name: string,
    /** Link to the shared registry (groups only; null while unlinked). */
    directoryId?: string | null,
}

/**
 * Enum representing user roles
 */
export enum UserRoleEnum {
    Administrator = 1,
    AdvancedUser = 2,
    User = 3,
    NoAccess = 4,
}  